<template>
  <div class="dashboard">
    <div class="main-content">
      <navbar-dashboard name="Reporte de Sobrepesos"></navbar-dashboard>

      <!-- Modal editar sobrepeso -->
      <b-modal ref="editOverWeight" hide-footer title="Editar Cargos Adicionales" size="md">
        <div class="p-3">
          <form @submit.prevent="updateOverWeight">
            <div class="form-group">
              <label>Cargo adicional <sup>*</sup></label>
              <input type="number" class="form-control" v-model="overweight" required
                v-b-tooltip.hover.top="'Ingresa el peso excedente en kilogramos'">
            </div>
            <div class="form-group">
              <label>Costo <sup>*</sup></label>
              <input type="number" class="form-control" v-model="cost_overweight" required
                v-b-tooltip.hover.top="'Ingresa el costo adicional'">
            </div>
            <div class="text-right">
              <button class="btn btn-light mr-2" @click="hideModalOverWeight"
                v-b-tooltip.hover.top="'Cancelar edición'">Cancelar</button>
              <button type="submit" class="btn btn-primary">Guardar cambios</button>
            </div>
          </form>
        </div>
      </b-modal>

      <div class="ew-view">
        <page-header title="Cargos adicionales"
          subtitle="Diferencias de peso y cargos extra que la paquetería aplicó a tus envíos.">
          <json-excel class="btn btn-outline-secondary" :data="shipmentsExport" title="Exportar" name="overweight.xls">
            <i class="bi bi-file-earmark-spreadsheet mr-1"></i> Exportar a Excel
          </json-excel>
        </page-header>

        <div class="card ew-filters mb-3">
          <div class="form-row">
            <div class="col-md-5 form-group">
              <label for="overweight-search">Buscar</label>
              <input id="overweight-search" type="search" class="form-control" v-model="overweightSearch"
                placeholder="Cargo adicional, servicio o número de guía">
            </div>
          </div>
        </div>

        <div class="ew-table-scroll">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Fecha de guía</th>
                <th>Servicio</th>
                <th class="ew-num">Cargo adicional</th>
                <th class="ew-num">Costo</th>
                <th>Estatus</th>
                <th>N° de guía</th>
                <th class="ew-num">Total del envío</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, i) in filteredOverweightShipments" :key="i" @dblclick="gotoShipmentDetails(s._id)">
                <td class="text-nowrap">{{ formatDate(s.created_at) }}</td>
                <td>
                  <div class="font-weight-bold">{{ s.selected_service.carrier | carrierName }}</div>
                  <div class="text-muted small">{{ s.selected_service.carrier_service_name | serviceName }}</div>
                </td>
                <td class="ew-num">{{ s.overweight }} kg</td>
                <td class="ew-num">{{ s.cost_overweight | money }}</td>
                <td>
                  <span class="badge" :class="s.overweight_paid ? 'badge-success' : 'badge-warning'">
                    {{ s.overweight_paid ? 'Pagado' : 'Pendiente' }}
                  </span>
                </td>
                <td class="text-nowrap">{{ numberGuide(s.number_guide) }}</td>
                <td class="ew-num font-weight-bold">{{ s.selected_service.total_amount | money }}</td>
              </tr>
              <tr v-if="!filteredOverweightShipments || filteredOverweightShipments.length === 0">
                <td colspan="7" class="p-0">
                  <empty-state icon="bi bi-receipt-cutoff"
                    :title="overweightSearch ? 'Sin resultados para tu búsqueda' : 'Sin cargos adicionales'"
                    :text="overweightSearch ? 'Prueba con otro cargo, servicio o número de guía.' : 'Cuando una paquetería aplique una diferencia de peso o un cargo extra, aparecerá aquí.'" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <table-pagination v-if="filteredOverweightShipments && filteredOverweightShipments.length"
          :page="shipments.page || 1" :total-pages="shipments.totalPages || 1" @change="goToPage" />
      </div>

    </div>
  </div>
</template>

<style scoped>
</style>


<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import commons from '../commons'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import JsonExcel from "vue-json-excel";

export default {
  name: 'Dashboard',

  data() {
    return {
      key: '',
      overweightSearch: '', // Texto de búsqueda para sobrepesos
      statusGuide: [],
      message: "",
      dismissSecs: 5,
      dismissCountDown: 0,
      selected: [],
      currentPage: 1,
      searchByKeywordCriteria: '',
      guideStatusFilter: 'all',
      paquetes: 'all',
      availableCarriers: [],
      selectedService: 'Servicios',
      filterShipmentsTimeoutID: '',
      filter: [],
      services: {
        dhl: ["EXPRESS DOMESTIC 10:30", "EXPRESS DOMESTIC", "EXPRESS DOMESTIC 12:00"],
        redpack: ["ECOEXPRESS", "EXPRESS"],
        ampm: ["ESTANDAR", "EXPRESS"]
      },
      date_ini: new Date(),
      openDate: new Date(),
      date_fin: new Date(),
      service: '',
      status: '',
      shipmentsExport: [],
      shipmentId: '',
      overweight: '',
      cost_overweight: '',
    }
  },

  created() {
    this.setNewShipmentEcommerce(null);
    this.getUser()
    this.getAllShipmentsOverweight(``)
    this.getMarketplace()
    this.getAllAvailableCarriers()

  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    carrierAndServiceCarrier(serviceCarrier) {
      if (this.services.dhl.includes(serviceCarrier)) {
        return `DHL - ${this.localCapitalize(serviceCarrier)}`
      } else if (this.services.redpack.includes(serviceCarrier)) {
        return `Redpack - ${this.localCapitalize(serviceCarrier)}`
      } else if (this.services.ampm.includes(serviceCarrier)) {
        return `AMPM - ${this.localCapitalize(serviceCarrier)}`
      } else {
        return `Fedex - ${this.localCapitalize(serviceCarrier)}`
      }
    },
    statusShipments() {
      let status = false
      this.selected.forEach(element => {
        if (element.status) {
          status = true
        }
      });
      return status
    },
    showModal() {
      this.$refs.myModalRef.show()
    },
    hideModal() {
      this.$refs.myModalRef.hide()
    },
    localCapitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    numberGuide(number, status, i) {
      if (number !== null) {
        return number
      } else {
        return "Sin numero de guia"
      }
    },
    obtenerStatus(number) {
      if (number !== null) {
        for (var i = 0; i < this.guideStatus.length; i++) {
          if (this.guideStatus[i].number_guide == number) {
            return this.guideStatus[i].messge
          }
        }
      }
      else {
        return "Sin guía"
      }

    },
    editOverWeight(id, overweight, cost_overweight) {
      this.shipmentId = id
      this.overweight = overweight
      this.cost_overweight = cost_overweight
      this.showModalOverWeight()
    },
    hideModalOverWeight() {
      this.$refs.editOverWeight.hide()
    },
    showModalOverWeight() {
      this.$refs.editOverWeight.show()
    },
    updateOverWeight(id, overweight) {

      axios
        .put(`${commons.apiURL}/api/v1/shipments/${this.shipmentId}`, {
          overweight: this.overweight,
          cost_overweight: this.cost_overweight
        })
        .then(response => {
          console.log(response.status)
          if (response.status == 200) {
            this.hideModalOverWeight()
          }
        })
        .catch(error => {
          console.error(error)
        })

    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    customFormatter(date) {
      return moment(String(date)).format('DD/MM/YYYY')
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    gotoShipmentDetails(id) {
      this.$router.push(`/shipments/${id}`)
    },
    gotoShipmentEcommerce(index) {
      this.setNewShipmentEcommerce(this.marketplace[index]);
      this.$router.push(`/`)
    },
    previousPage() {
      axios.get(this.shipments.previous).then(response => {
        this.setGuideStatus([])
        this.setShipments(response.data)
        this.getStatusGuide({ data: response.data.docs }).then((status) => {
          console.log(status);
          this.setGuideStatus(status)
        })

      })
    },
    nextPage() {

      axios.get(this.shipments.next).then(response => {
        this.setGuideStatus([])
        this.setShipments(response.data)
        this.getStatusGuide({ data: response.data.docs }).then((status) => {
          this.setGuideStatus(status)
        })
      })
    },
    goToPage(page) {
      this.getAllShipmentsOverweight(`&limit=10&page=${page}`)
    },
    getAllShipmentsOverweight(page) {
      console.log(`${commons.apiURL}/api/v1/overweight/user/${localStorage.getItem('ew-user-id')}service=${this.service}&status=${this.status}&filter=${this.searchByKeywordCriteria}${page}`);
      axios
        .get(`${commons.apiURL}/api/v1/overweight/user/${localStorage.getItem('ew-user-id')}?service=${this.service}&status=${this.status}&filter=${this.searchByKeywordCriteria}${page}`)
        .then(response => {
          this.setGuideStatus([])
          this.setShipments(response.data)
          this.getStatusGuide({ data: response.data.docs }).then((status) => {
            console.log(status);
            this.setGuideStatus(status)
          })
          this.actualizaShipmentsExport()
        })
    },
    actualizaShipmentsExport() {
      this.shipmentsExport = [];
      for (var i = 0; i < this.shipments.count; i++) {
        let s = this.shipments.docs[i];
        let rowExport =
        {
          fecha: this.formatDate(s.created_at),
          servicio: s.selected_service.carrier + ' - ' + s.selected_service.carrier_service_name,
          sobrepeso: s.overweight,
          costo_sobrepeso: s.cost_overweight,
          estatus_sobrepeso: s.overweight_paid ? 'Pagado' : 'Pendiente',
          guia: this.numberGuide(s.number_guide),
          total: s.selected_service.total_amount
        };
        this.shipmentsExport.push(rowExport);
      }
    },
    availablePages(page) {
      const result = []
      let initial = page > 1 ? page - 1 : 1
      let final = page < this.shipments.pages ? page + 1 : this.shipments.pages

      for (let i = initial; i <= final; i++) {
        result.push(i)
      }

      return result
    },
    deletebadg(i) {
      this.filter.splice(i, 1);
    },
    filterShipments(criteria) {
      this.searchByKeywordCriteria = criteria
      this.getAllShipmentsOverweight(``)
    },
    filterShipmentsByGuideStatus(status) {
      this.status = status == 'all' ? '' : status
      this.getAllShipmentsOverweight(``)
    },
    getAllAvailableCarriers() {
      api.shipment
        .getAllAvailableCarriers()
        .then(response => {
          this.availableCarriers = response.data

        })
        .catch(error => console.log(error))
    },
    filterShipmentsByCarriersServices(service) {

      this.service = service == 'Servicios' ? '' : service
      this.getAllShipmentsOverweight(``)
    },
    downloadTracking(id) {
      const url = `${commons.apiURL}/api/public/${id}.pdf`
      return url
      // axios.get(url).then(response => console.log('xxx'))
    },

    pmeayntsMany() {

      if (this.statusShipments()) {
        this.showModal()
      } else {
        this.setPaymentShipments(this.selected)
        this.$router.push('/payment/shipments/many')
      }
    },
    filterIsTrue(array_filter) {
      let status = true;
      array_filter.forEach(element => {
        if (!element) {
          status = false;
        }
      });
      return status;
    },
    getFilterStatus(items, shipment) {
      let list_filter = [];
      items.forEach(item => {
        if (shipment.ecommerce_type === undefined) {

          if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
            list_filter.push(true)
          } else if (shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())) {
            list_filter.push(true)
          } else if (shipment.selected_service.carrier_service_name.includes(item)) {
            list_filter.push(true)
          } else if (item.toLowerCase() == "true" || item.toLowerCase() === "false") {
            let guide = (item.toLowerCase() == 'true') ? true : false
            if (shipment.status === guide) {
              list_filter.push(true)
            } else {
              list_filter.push(false)
            }
          } else {
            list_filter.push(false)
          }
        } else {
          if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
            list_filter.push(true)
          } else if (shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())) {
            list_filter.push(true)
          } else {
            list_filter.push(false)
          }
        }
      });
      return list_filter;
    },
    printBadge(text) {
      if (text == "true" || text == "false") {
        return (text == 'true') ? 'Pagado' : 'Guia sin pago'
      } else {
        return text
      }
    },
    ...mapMutations(['setShipments']),
    ...mapActions(['getStatusGuide', 'getUser', 'getMarketplace']),
    ...mapMutations(["setGuideStatus", "setPaymentShipments"]),
    ...mapMutations(['setNewShipmentEcommerce'])
  },
  computed: {
    ...mapGetters(['shipments', 'guideStatus', 'user', "paymentShipments", 'marketplace']),
    filteredOverweightShipments() {
      if (!this.shipments || !this.shipments.docs) return []

      if (!this.overweightSearch) return this.shipments.docs

      const keyword = this.overweightSearch.toLowerCase()

      return this.shipments.docs.filter(s =>
        (s.selected_service.carrier.toLowerCase().includes(keyword)) ||
        (s.selected_service.carrier_service_name.toLowerCase().includes(keyword)) ||
        (s.number_guide.toString().includes(keyword)) ||
        (s.overweight.toString().includes(keyword)) ||
        (s.cost_overweight.toString().includes(keyword)) ||
        (s.overweight_paid ? 'pagado' : 'pendiente').includes(keyword)
      )
    },
    shipmentWithGuide() {
      return []
    },
    shipmentWithoutGuide() {
      return []
    },
    selectAll: {
      get: function () {
        return this.shipments ? this.selected.length == this.shipments.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.shipments.forEach(function (shipment) {
            selected.push(shipment);
          });
        }
        this.selected = selected;
      }
    },
    shipmentsFilter: function () {
      try {
        return this.shipments.filter((shipment) => {
          return this.filterIsTrue(this.getFilterStatus(this.filter, shipment))
        });
      } catch (error) {
        console.log("this.shipments", this.shipments)
      }

    },
    marketplaceList: function () {
      if (this.key.length > 2) {
        return this.marketplace.filter((item) => {
          let word = this.key.toLowerCase().trim()
          if (item.destination_direction.full_name.toLowerCase().trim().includes(word)) {
            return true
          } else {
            return false
          }
        })
      } else {
        return this.marketplace
      }

    }
  },
  components: {
    'navbar-dashboard': Navbar,
    Datepicker,
    JsonExcel,

  },

}

</script>



// WEBPACK FOOTER //
// src/components/Overweight.vue